export const ROUTES = {
    unauthorized:"/unauthorized"
}